<template>
    <div class="MChart" style="display: flex;">
        <canvas style="
            height: 290px;
            width: 290px;
            margin: 0 auto;
        " class="myCanvas"></canvas>
        <div class="legend"></div>
    </div>
</template>

<script>

export default {
    props:{
        dataset:[],
        dataset2:[],
        labels:[],
        labels2:[],
        keyV:{
            default:0
        }
        
    },
    watch:{

    },
    data(){
        return {
            all1:0,
            all2:0,
        }
    },
    mounted(){
        var height=400;
        var width=400;
        var radius=350;
        var radius2=250;
        this.all1=0;
        this.all2=0;
        this.dataset.forEach( num => {
            this.all1 += num;
        })
        this.dataset2.forEach( num => {
            this.all2 += num;
        })
        var myCanvas = document.getElementsByClassName("myCanvas")[this.keyV];
        var MChart = document.getElementsByClassName("MChart")[this.keyV];
        console.log(MChart)
        myCanvas.width = 400;
        myCanvas.height = 400;
        var ctx = myCanvas.getContext("2d");
        ctx.restore();
        
        var m=0;
        for(var i=0;i<this.dataset.length;i++){
            var num1=this.dataset[i];
            var x1=num1/this.all1*(2*Math.PI)
            this.drawPieSlice(ctx, 200, 200, 200, m,m+x1, this.labels[i].color, "#FFF");
            

            m=m+x1
        }
        var m2=0;
        for(var j=0;j<this.dataset2.length;j++){
            var num2=this.dataset2[j];
            var x2=num2/this.all2*(2*Math.PI)
            this.drawPieSlice(ctx, 200, 200, 150, m2,m2+x2, this.labels2[j].color, "#FFF");
            m2=m2+x2;
            
        }
         this.drawPieSlice(ctx, 200, 200, 100, 0,(2*Math.PI), '#FFF', "#FFF");
        let pIndex = 0;
        let legend = document.getElementsByClassName("legend")[this.keyV];
        let ul = document.createElement("ul");
        ul.style.display = "flex";
        ul.style.flexDirection = "column";
        ul.style.height = "20px";
        ul.style.marginTop = "20px";
        legend.append(ul);
        for (let ctg of Object.keys(this.labels)) {
            let li = document.createElement("li");
            li.style.listStyle = "none";
            li.style.display = "flex";
            li.style.borderLeft =
                "10px solid " + this.labels[pIndex].color;
            li.style.padding = "5px";
            li.textContent = this.labels[pIndex].label;
            ul.append(li);
            console.log(ctg)
            pIndex++;
        }
        pIndex = 0;
        for (let ctg of Object.keys(this.labels2)) {
            let li = document.createElement("li");
            li.style.listStyle = "none";
            li.style.display = "flex";
            li.style.borderLeft =
                "10px solid " + this.labels2[pIndex].color;
            console.log(ctg)
            li.style.padding = "5px";
            li.textContent = this.labels2[pIndex].label;
            //li.style.color = "#FFF";
            ul.append(li);
            pIndex++;
        }
        this.drawArc(ctx, 200, 200, 150, 0, Math.PI*2, "#FFF");
        this.drawArc(ctx, 200, 200, 101, 0, Math.PI*2, "#FFF");
        
        

    var startAngle =0; //-Math.PI / 2;
    
    for (var categ1 in this.dataset) {
      var val1 = this.dataset[categ1];
      var sliceAngle1 = (2 * Math.PI * val1) / this.all1;
      var labelX1 =
        width / 2 +
        (radius / 2) * Math.cos(startAngle + sliceAngle1 / 2);
      var labelY1 =
        height / 2 +
        (radius / 2) * Math.sin(startAngle + sliceAngle1 / 2);
    
        var labelText1 = Math.round(val1);
        //ctx.fillStyle = "white";
        ctx.font = "20px Khand";
        ctx.fillText(labelText1 , labelX1+10, labelY1+10);
        startAngle += sliceAngle1;
    }
    var startAngle2 =0; //-Math.PI / 2;
    
    for (var categ2 in this.dataset2) {
      var val2 = this.dataset2[categ2];
      var sliceAngle2 = (2 * Math.PI * val2) / this.all1;
      var labelX2 =
        width / 2 +
        (radius2 / 2) * Math.cos(startAngle2 + sliceAngle2 / 2);
      var labelY2 =
        height / 2 +
        (radius2 / 2) * Math.sin(startAngle2 + sliceAngle2 / 2);
    
        var labelText2 = Math.round(val2);
        //ctx.fillStyle = "white";
        ctx.font = "20px Khand";
        ctx.fillText(labelText2 , labelX2+10, labelY2+10);
        startAngle2 += sliceAngle2;
    }
        // for (var i=0;i<this.labels2.length;i++) {
        //    var labelText = Math.round(this.dataset2[i]);
        //     ctx.fillStyle = "white";
        //     ctx.font = "25px Khand";
        //     ctx.fillText(labelText , 100,100);
        // }
        
    },
    methods:{
       drawLine(ctx, startX, startY, endX, endY, color){
                ctx.save();
                ctx.strokeStyle = color;
                ctx.beginPath();
                ctx.moveTo(startX,startY);
                ctx.lineTo(endX,endY);
                ctx.stroke();
                ctx.restore();
        },
        drawArc(ctx, centerX, centerY, radius, startAngle, endAngle, color) {
            ctx.save();
            ctx.strokeStyle = color;
            ctx.beginPath();
            ctx.arc(centerX, centerY, radius, startAngle, endAngle);
            ctx.stroke();
            ctx.restore();
        },
        drawPieSlice(
            ctx,
            centerX,
            centerY,
            radius,
            startAngle,
            endAngle,
            fillColor,
            strokeColor
            ) {
            ctx.save();
            ctx.fillStyle = fillColor;
            ctx.strokeStyle = strokeColor;
            ctx.beginPath();
            ctx.moveTo(centerX, centerY);
            ctx.arc(centerX, centerY, radius, startAngle, endAngle);
            ctx.closePath();
            ctx.fill();
            //ctx.stroke();
            ctx.restore();
        },
        drawLegend() {
            // let pIndex = 0;
            // let legend = document.querySelector("div[for='myCanvas']");
            // let ul = document.createElement("ul");
            // legend.append(ul);
            // for (let ctg of Object.keys(this.options.data)) {
            // let li = document.createElement("li");
            // li.style.listStyle = "none";
            // li.style.borderLeft =
            //     "20px solid " + this.colors[pIndex % this.colors.length];
            // li.style.padding = "5px";
            // li.textContent = ctg;
            // ul.append(li);
            // pIndex++;
            // }
        }
    }
}
</script>

<style>

</style>